import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnInit,
    ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { TreeNode } from "primeng/api";
import { forkJoin, Observable } from "rxjs";
import {
    DrawingRegister,
    DrawingRegisterService,
} from "../../../services/sitework/drawing-register.service";
import { cloneDeep } from "lodash";
import { RenameFileByUrlRequest } from "../../dms/dms.models";
import { DmsService } from "../../dms/dms.service";

declare var $: any;

@Component({
    standalone: false,
    templateUrl: "./dms-buttons.component.html",
    providers: [DmsService, DrawingRegisterService],
})
export class FormlyDmsButtons extends FieldType<FieldTypeConfig> implements OnInit {
    @ViewChild("closeModalButton") closeModalButton: ElementRef;
    @ViewChild("modal") modal;
    @ViewChild("drawingRegistersModal", { static: false })
    drawingRegistersModal: ElementRef;
    @ViewChild("drawingRegisterButton_Close")
    private drawingRegisterButton_Close: ElementRef;
    drawingRegistersModalVisible: boolean = false;
    drawingRegisters: any[] = [];
    enableDrawingRegister: boolean = false;
    showLookups_Levels: boolean = false;
    showLookups_Statuses: boolean = false;
    showLookups_Elements: boolean = false;
    showLookups_Packages: boolean = false;
    showLookups_Elevations: boolean = false;
    showLookups_Cores: boolean = false;
    selectedPrimaryFiles: any[] = [];
    selectedSecondaryFiles: any[] = [];
    selectedDocuments: any[] = [];
    selectedPath: string = "";
    selectionMode: string = "checkbox";
    projectId: number = 0;
    route: ActivatedRoute;
    faInfoSign = faInfoCircle;
    showModal: boolean = false;

    constructor(
        route: ActivatedRoute,
        private dmsService: DmsService,
        private changeDetectorRef: ChangeDetectorRef,
        private drawingRegisterService: DrawingRegisterService
    ) {
        super();
        this.route = route;
    }

    async ngOnInit() {
        let params = this.route.snapshot.params;

        if (params["projectId"]) {
            this.projectId = +params["projectId"];
            this.dmsService.projectId = this.projectId;

            if (this.props.dmsButtons) {
                this.props.dmsButtons.forEach((dmsbutton) => {
                    if (dmsbutton.isDrawingRegister) {
                        this.enableDrawingRegister = true;
                    }
                });
            }
        }
    }

    ngAfterViewInit() {
        $(this.modal.nativeElement).on("hidden.bs.modal", () => {
            this.showModal = false;
            this.changeDetectorRef.detectChanges();
        });
        $(this.modal.nativeElement).on("show.bs.modal", () => {
            this.showModal = true;
            this.changeDetectorRef.detectChanges();
        });
    }

    onChangeDmsUrl(newPath: string) {
        this.selectedPath = newPath;
    }

    selectionChanged() {
        this.changeDetectorRef.detectChanges();
    }

    addDocuments(selectedDocs: any[]) {
        var requests: Observable<any>[] = [];

        selectedDocs.forEach((doc: TreeNode) => {
            if (doc.type != "Folder") {
                var renameRequest: RenameFileByUrlRequest = {
                    oldUrl: doc.data.url,
                    newPath: <string>this.props.path,
                    isCopy: true,
                    newFileName: doc.data.fileName,
                    oldPathProjectId: this.props.skipProjectId ? 0 : null,
                    resetLabel: true,
                };

                requests.push(this.dmsService.renameFileByUrl(renameRequest));
            }
        });

        forkJoin(requests).subscribe(
            () => {
                if (this.props.uploadComplete) {
                    this.props.uploadComplete();
                }
            },
            () => { }
        );

        this.selectedDocuments = [];
        this.closeModalButton?.nativeElement?.click();
    }

    cancel() {
        this.selectedDocuments = [];
        this.closeModalButton?.nativeElement?.click();
    }

    ngOnDestroy() {
        this.selectedDocuments = [];
        this.closeModalButton?.nativeElement?.click();
        if (this.enableDrawingRegister) {
            this.selectedPrimaryFiles = [];
            this.selectedSecondaryFiles = [];
            this.drawingRegisters = [];
            this.drawingRegisterButton_Close?.nativeElement?.click();
        }
    }

    async openDrawingRegisterModal() {
        if (this.enableDrawingRegister) {
            this.drawingRegisterService.projectId = this.projectId;
            var data = await this.drawingRegisterService.getAll().toPromise();

            if (data) {
                this.drawingRegisters = cloneDeep(data as any[]);

                for (let drawingEntity of data as any[]) {
                    let entity = this.drawingRegisters.find(
                        (x) => x.id == drawingEntity.id
                    );
                    if (
                        entity.drawingRegisterAttachments &&
                        entity.drawingRegisterAttachments.length > 0
                    ) {
                        entity.primaryFile = entity.drawingRegisterAttachments.filter(
                            (attachment) => attachment.type == "PrimaryFile"
                        )[0];
                        entity.secondaryFiles = entity.drawingRegisterAttachments.filter(
                            (attachment) =>
                                attachment.type == "SecondaryFile" &&
                                attachment.revision == entity.revision
                        );

                        entity.originalFileName = entity.name;
                        entity.name = entity.primaryFile.fileUrl;
                        entity.isUrl = true;
                        entity.dateTimeIssued = this.getLocalDateTime(
                            entity.dateTimeIssued
                        ); 
                        if (entity.levels?.length > 0)
                            this.showLookups_Levels = true;
                        if (entity.drawingRegisterStatus != null)
                            this.showLookups_Statuses = true;
                        if (entity.elements?.length > 0)
                            this.showLookups_Elements = true;
                        if (entity.packages?.length > 0)
                            this.showLookups_Packages = true;
                        if (entity.elevations?.length > 0)
                            this.showLookups_Elevations = true;
                        if (entity.cores?.length > 0)
                            this.showLookups_Cores = true;
                    } else {
                        const index: number = this.drawingRegisters.indexOf(
                            entity
                        );
                        if (index !== -1) {
                            this.drawingRegisters.splice(index, 1);
                            this.drawingRegisters = this.drawingRegisters;
                        }
                    }
                }
            }
        }
        this.drawingRegistersModalVisible = true;
        this.changeDetectorRef.detectChanges();
        $(this.drawingRegistersModal.nativeElement).modal('show');
    }

    cancelDrawingRegisters($event) {
        this.selectedPrimaryFiles = [];
        this.selectedSecondaryFiles = [];
        this.drawingRegisters.forEach((drawingRegister) => {
            drawingRegister.selected = false;
        });
        this.drawingRegisters = [];
        this.drawingRegisterButton_Close?.nativeElement?.click();
        $event.preventDefault();
        $event.stopPropagation();
    }

    getLocalDateTime(date: string | Date): Date {
        date = new Date(date);

        let timezoneOffset = date.getTimezoneOffset();

        date = new Date(date.getTime() - timezoneOffset * 60000);

        return date;
    }

    addAllSelectedFiles($event) {
        this.addPrimaryFiles($event, true);
        this.addSecondaryFiles($event, true);
        this.selectedPrimaryFiles = [];
        this.selectedSecondaryFiles = [];
    }

    addPrimaryFiles($event,isFromAll = false) {
        $event.preventDefault();
        $event.stopPropagation();
        var requests: Observable<any>[] = []; 
        this.selectedPrimaryFiles.forEach((primaryFile: any) => {
            var renameRequest: RenameFileByUrlRequest = {
                oldUrl: primaryFile.fileUrl,
                newPath: <string>this.props.path,
                isCopy: true,
                newFileName: primaryFile.fileName,
                oldPathProjectId: this.props.skipProjectId ? 0 : null,
                resetLabel: true,
            };

            requests.push(this.dmsService.renameFileByUrl(renameRequest));
        });

        forkJoin(requests).subscribe(
            () => {
                if (this.props.uploadComplete) {
                    this.props.uploadComplete();
                }
            },
            () => { }
        );
        if (!isFromAll) {
            this.selectedPrimaryFiles = [];
            this.selectedSecondaryFiles = [];
        }
        this.drawingRegisters.forEach((drawingRegister) => {
            drawingRegister.selected = false;
        });
    }

    addSecondaryFiles($event, isFromAll = false) {
        $event.preventDefault();
        $event.stopPropagation();
        var requests: Observable<any>[] = []; 
        this.selectedSecondaryFiles.forEach((secondaryFile: any) => {
            var renameRequest: RenameFileByUrlRequest = {
                oldUrl: secondaryFile.fileUrl,
                newPath: <string>this.props.path,
                isCopy: true,
                newFileName: secondaryFile.fileName,
                oldPathProjectId: this.props.skipProjectId ? 0 : null,
                resetLabel: true,
            };

            requests.push(this.dmsService.renameFileByUrl(renameRequest));
        });

        forkJoin(requests).subscribe(
            () => {
                if (this.props.uploadComplete) {
                    this.props.uploadComplete();
                }
            },
            () => { }
        );
        if (!isFromAll) {
            this.selectedPrimaryFiles = [];
            this.selectedSecondaryFiles = [];
        }
        this.drawingRegisters.forEach((drawingRegister) => {
            drawingRegister.selected = false;
        });
    }

    onHeaderCheckboxClicked($event) {
        this.selectedPrimaryFiles = [];
        this.selectedSecondaryFiles = [];
        (
            this.drawingRegisters.filter(
                (drawingRegister) => drawingRegister.selected
            ) || []
        ).forEach((selectedDrawingRegister) => {
            this.selectedPrimaryFiles.push(selectedDrawingRegister.primaryFile);
            (selectedDrawingRegister.secondaryFiles || []).forEach(
                (secondaryFile) => {
                    this.selectedSecondaryFiles.push(secondaryFile);
                }
            );
        });
    }

    rowSelected($event: any): void {
        this.selectedPrimaryFiles = [];
        this.selectedSecondaryFiles = [];
        (
            this.drawingRegisters.filter(
                (drawingRegister) => drawingRegister.selected
            ) || []
        ).forEach((selectedDrawingRegister) => {
            this.selectedPrimaryFiles.push(selectedDrawingRegister.primaryFile);
            (selectedDrawingRegister.secondaryFiles || []).forEach(
                (secondaryFile) => {
                    this.selectedSecondaryFiles.push(secondaryFile);
                }
            );
        });
    }

    rowUnselected($event: any): void {
        this.selectedPrimaryFiles = [];
        this.selectedSecondaryFiles = [];
        (
            this.drawingRegisters.filter(
                (drawingRegister) => drawingRegister.selected
            ) || []
        ).forEach((selectedDrawingRegister) => {
            this.selectedPrimaryFiles.push(selectedDrawingRegister.primaryFile);
            (selectedDrawingRegister.secondaryFiles || []).forEach(
                (secondaryFile) => {
                    this.selectedSecondaryFiles.push(secondaryFile);
                }
            );
        });
    }
}
